import React from 'react'
import type { ProductOptionsConfiguratorData } from '@vp/product-options'

import { SiteMain, GridContainer, BoundedContent, MainContentStart, useScreenClass } from '@vp/swan'

import { ProjectsContextProvider } from '../root/contexts/ProjectsContext'
import Projects from './Projects'
import { WorksDataProvider } from '../root/contexts/WorksDataContext'
import { AlertContextProvider } from '../root/contexts/AlertContext'
import { QuantityFooter } from './footer/QuantityFooter'
import { RelatedProducts } from './relatedProduct'
import { CarouselLink } from '../shared/CarouselLink'
import { ColorOption } from './colorOption/ColorOption'
import { CarouselScrollContextProvider } from '../root/contexts/CarouselScrollContext'
import { RelatedProductsContextProvider } from '../root/contexts/RelatedProductsContext'
import { EXPERIMENTS, useABTest } from '../root/contexts/ABTestContext'
import AlertCollection from '../root/AlertCollection'

type QuantityProps = {
  configuratorData?: ProductOptionsConfiguratorData
}

const Quantity: React.FC<QuantityProps> = ({ configuratorData }) => {
  const { currentExperiments } = useABTest()
  const screenClass = useScreenClass()

  const isMobile = screenClass === 'xs'

  const hasColorOptions =
    EXPERIMENTS['ADD_OTHER_COLORS'] && EXPERIMENTS['ADD_OTHER_COLORS'].variations['TEST'] === currentExperiments[EXPERIMENTS['ADD_OTHER_COLORS'].key]

  return (
    <AlertContextProvider>
      <ProjectsContextProvider>
        <WorksDataProvider>
          <RelatedProductsContextProvider>
            <CarouselScrollContextProvider>
              <SiteMain className="quantity-selection-container">
                <MainContentStart />
                <BoundedContent className="bounded-content">
                  <GridContainer>
                    <AlertCollection />
                    <Projects configuratorData={configuratorData} />
                  </GridContainer>
                  {!isMobile && <CarouselLink hasColorOptions={hasColorOptions} />}
                  {hasColorOptions && <ColorOption />}
                  <RelatedProducts />
                </BoundedContent>
              </SiteMain>
              <QuantityFooter />
            </CarouselScrollContextProvider>
          </RelatedProductsContextProvider>
        </WorksDataProvider>
      </ProjectsContextProvider>
    </AlertContextProvider>
  )
}

export default Quantity
